import React from 'react';
import { observer } from 'mobx-react';
import { useClientStore, useAppManager } from 'apps/hooks';
import FilesAppManager from 'apps/files/appManager';
import { ShareCard } from 'apps/share/blocks/shareCard';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ShareFileListItem } from 'apps/share/blocks/shareFileListItem';
import { ViewTypeEnum } from 'types';

const Files = observer(({ maxItems }: { maxItems?: number }) => {
  const clientStore = useClientStore();
  const shouldCreate = !!clientStore.signedInProfile;
  const appManager = useAppManager(FilesAppManager, null, {}, shouldCreate);

  if (!appManager) return null;
  const { sharedFilesConnection } = appManager;
  if (!sharedFilesConnection) return null;
  const sharedFiles = sharedFilesConnection.arrayApp;

  const { totalCount } = sharedFilesConnection;
  const numRows = sharedFiles?.upstream?.length;

  return (
    <>
      <CardSection
        invisible={appManager.loading}
        subTitle=' '
        tooltip='Share new File.'
        owner
        ownerName={clientStore.signedInProfile.user.fullName}
        cardApp={sharedFiles}
        gridColumns={1}
        CardComponent={ShareFileListItem}
        noDataCardType='sharedFile'
        maxItems={maxItems}
        mediumColumns={1}
        gridGaps='16px'
        showButton={numRows < totalCount}
        wrapperStyle={{ marginBottom: 32, marginTop: totalCount ? 6 : 16 }}
        showAllRouteName='workspace.spaceFiles'
        showAllRouteParams={{ spacePath: clientStore.activeSpace?.path }}
      />
    </>
  );
});

export default Files;
